// auto-access.ts · Resolución de entitlement de Robotea Auto en el frontend.
// Espejo del patrón roboteam-access.ts — fail-closed: false por defecto,
// true solo cuando 'robotea-auto' aparece en los slugs matriculados.
//
// Owner: Carlos Beltrán · 2026-07-08 · F-CAMPUS-AUTO-ACCESS-001
//
// Nota: OFFER_LINKS.auto existe en offer-links.ts pero aún no se usa en la UI
// del campus (directiva del comentario en offer-links.ts). autoCtaHref() apunta
// a la ruta in-campus '/auto/activar' (decisión Jaime, sell-inside-campus).

/** Slug de entitlement de Robotea Auto (course_slug matriculado). */
export const ROBOTEA_AUTO_SLUG = 'robotea-auto';

/**
 * ¿El alumno tiene acceso a Robotea Auto?
 *
 * Fail-closed: devuelve `true` solo si `robotea-auto` está presente en los
 * slugs matriculados; `false` para lista vacía o cualquier otro conjunto de
 * slugs. La decisión de seguridad REAL es server-side; esto solo controla
 * qué se MUESTRA (deny-by-default en ausencia del entitlement).
 */
export function hasAuto(enrolledSlugs: Iterable<string>): boolean {
  for (const s of enrolledSlugs) {
    if (s === ROBOTEA_AUTO_SLUG) return true;
  }
  return false;
}

/**
 * Ruta del CTA de venta cruzada de Robotea Auto dentro del campus.
 * Los alumnos sin el entitlement son llevados a '/auto/activar'
 * (venta in-campus, decisión Jaime).
 */
export function autoCtaHref(): string {
  return '/auto/activar';
}
